import { REQUEST_MENU_PERMISSIONS, REQUEST_RESET_STATE_LOGIN, RESPONSE_VERIFIED_USER } from 'orden_express/login/loginEpic.js';

const initialState = {
    requestVerifiedUser: {},
    messageLogin: 0,
    requestMenuPermissions: [],
    responseVerifiedUser: {},
};

const loginReducer = (state = initialState, action) => {
    //console.info(action.type, action);
    switch (action.type) {

        case REQUEST_RESET_STATE_LOGIN:
            return {
                ...state,
                requestVerifiedUser: {},
                messageLogin: 0,
                requestMenuPermissions: [],
                responseVerifiedUser: {},
            };

        case REQUEST_MENU_PERMISSIONS:
            return {
                ...state,
                requestMenuPermissions: action.requestMenuPermissions,
            };

        case RESPONSE_VERIFIED_USER:
            return {
                ...state,
                responseVerifiedUser: action.responseVerifiedUser,
                messageLogin: action.responseVerifiedUser.errorState === false ? 2 : action.responseVerifiedUser.errorState === true ? 3 : 2
            };

        default:
            return state;
    }
}

export default loginReducer;